module.exports = __webpack_public_path__ + "assets_app/img/button-buttonboard.2a40fc82.svg";